import { t } from "@lingui/macro";

export const appliedFilterForKey = (
  appliedFiltersGroup: { [key: string]: string[] } | undefined,
  key: string
): string[] => {
  return (appliedFiltersGroup || {})[key] || [];
};

type AlgoliaProcessableItem = {
  label: string;
  value: string[];
  count: number;
  isRefined: boolean;
};

// NOTE: this is an hack to resolve the algolia infinite loop with anonymous functions
let staticDayGroupItemsTransformer;
export const dayGroupItemsTransformer = (): ((
  items: AlgoliaProcessableItem[]
) => AlgoliaProcessableItem[]) => {
  if (!staticDayGroupItemsTransformer) {
    staticDayGroupItemsTransformer = (
      items: AlgoliaProcessableItem[]
    ): AlgoliaProcessableItem[] => {
      const transformedItems = [...items]
        .sort((a, b) => {
          const aValue = parseInt(a.label.split(" - ", 2)[0], 10);
          const bValue = parseInt(b.label.split(" - ", 2)[0], 10);
          return aValue - bValue;
        })
        .map((item) => ({
          ...item,
          label: `${item.label} ${t`days`}`
        }));
      return transformedItems;
    };
  }
  return staticDayGroupItemsTransformer;
};

let staticNameSortingTransformer;
export const nameSortingTransformer = (): ((
  items: AlgoliaProcessableItem[]
) => AlgoliaProcessableItem[]) => {
  if (!staticNameSortingTransformer) {
    staticNameSortingTransformer = (items) => {
      const transformedItems = [...items].sort((a, b) => {
        return a.label.localeCompare(b.label);
      });
      return transformedItems;
    };
  }
  return staticNameSortingTransformer;
};

const destinationsNameForceSortingAsLastItems = [
  "Grand Voyage",
  "World Cruise",
  "Vuelta Al Mundo",
  "Volta Aol Mundo",
  "Weltreise",
  "Tour Du Monde"
];

function prefixDestinationForSorting(name: string): string {
  if (destinationsNameForceSortingAsLastItems.includes(name))
    return `ZZ${name}`;

  return name;
}

let staticDestinationNameSortingTransformer;
export const destinationNameSortingTransformer = (): ((
  items: AlgoliaProcessableItem[]
) => AlgoliaProcessableItem[]) => {
  if (!staticDestinationNameSortingTransformer) {
    staticDestinationNameSortingTransformer = (items) => {
      const transformedItems = [...items].sort((a, b) => {
        const aLabel = prefixDestinationForSorting(a.label);
        const bLabel = prefixDestinationForSorting(b.label);

        return aLabel.localeCompare(bLabel);
      });
      return transformedItems;
    };
  }
  return staticDestinationNameSortingTransformer;
};
